export default __webpack_public_path__ + "static/media/sirReginald.6e206021.png";